import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {createUseStyles, useTheme} from 'react-jss';
import LegalEntityComponent from '../../v2/components/legal-entity/LegalEntity';
import PaymentSpecificEntity from '../../v2/components/legal-entity/PaymentSpecificEntity';
import {getSettings} from '../../v2/selectors/selectors';

const useStyles = createUseStyles({
  footer: {
    background: props => props.theme.footer.backgroundColour,
    marginTop: 40,
    padding: props => (!props.isFooterWithLogo && '0 16px 36px'),
  },
});

export function PageFooter(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <footer className={classes.footer} data-test="PageFooter" role="contentinfo">
      <LegalEntityComponent />
      {props.shouldShowPaymentSpecificEntity && (
        <PaymentSpecificEntity />
      )}
    </footer>
  );
}

const mapStateToProps = (state) => {
  const settings = getSettings(state);
  const paymentOptions = state.payment?.options || [];
  const paymentMethodsToDisplaySpecificEntity = settings?.payment_methods_to_display_specific_entity || [];
  return {
    isFooterWithLogo: !!settings.is_footer_with_logo,
    shouldShowPaymentSpecificEntity: paymentOptions
      .some(option => paymentMethodsToDisplaySpecificEntity.includes(option.type))
      || paymentMethodsToDisplaySpecificEntity.includes(state?.start?.selectedPaymentMethod),
  };
};

PageFooter.propTypes = {
  isFooterWithLogo: PropTypes.bool,
  shouldShowPaymentSpecificEntity: PropTypes.bool,
};

export default connect(mapStateToProps)(PageFooter);
